/* cm-lp — carousel + hero counter cho landing page.
   Không phụ thuộc JS của theme; tự khởi tạo và chạy lại sau khi section
   được render lại trong theme editor. */

(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.cmLpReady === 'true') return;
    root.dataset.cmLpReady = 'true';

    var track = root.querySelector('.cm-lp-carousel__track');
    var controls = root.querySelector('.cm-lp-carousel__controls');
    var progress = root.querySelector('.cm-lp-carousel__progress');
    var prev = root.querySelector('[data-cm-lp-prev]');
    var next = root.querySelector('[data-cm-lp-next]');
    if (!track) return;

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function overflow() {
      return track.scrollWidth - track.clientWidth;
    }

    function sync() {
      var max = overflow();
      var scrollable = max > 1;

      if (controls) controls.hidden = !scrollable;
      if (!scrollable) return;

      var ratio = track.clientWidth / track.scrollWidth;
      if (progress) {
        progress.style.setProperty('--cm-lp-progress', Math.min(1, ratio).toFixed(4));
        progress.style.setProperty(
          '--cm-lp-progress-offset',
          (track.scrollLeft / track.scrollWidth).toFixed(4)
        );
      }

      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', sync, { passive: true });

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(sync).observe(track);
    } else {
      window.addEventListener('resize', sync);
    }

    sync();
  }

  /* Đếm số đơn trong ngày ở hero. Chỉ chạy khi section bật tuỳ chọn này. */
  function initProof(el) {
    if (el.dataset.cmLpReady === 'true') return;
    el.dataset.cmLpReady = 'true';

    var min = parseInt(el.dataset.proofMin, 10) || 0;
    var max = parseInt(el.dataset.proofMax, 10) || min;
    var suffix = el.dataset.proofSuffix || '';
    var target = min + Math.floor(Math.random() * Math.max(1, max - min + 1));

    function render(value) {
      el.textContent = value + '+ ' + suffix;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      render(target);
      return;
    }

    var start = Math.max(0, Math.floor(target * 0.6));
    var duration = 1200;
    var t0 = null;

    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / duration);
      var eased = 1 - Math.pow(1 - p, 3);
      render(Math.round(start + (target - start) * eased));
      if (p < 1) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.cm-lp-carousel').forEach(initCarousel);
    root.querySelectorAll('[data-cm-lp-proof]').forEach(initProof);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Theme editor render lại section → khởi tạo cho phần vừa chèn */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
